export default __webpack_public_path__ + "static/media/hht1_ep04_timeline_06_blank.df870f9b.png";